import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SuscriptionService } from 'src/app/service/suscription.service';
import { LoginService } from 'src/app/service/login.service';
import { DeviceSelectionService } from 'src/app/service/DeviceSelection.service'; 
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-campaigns',
  templateUrl: './campaigns.component.html',
  styleUrls: ['./campaigns.component.scss']
})
export class CampaignsComponent implements OnInit, OnDestroy {
  deviceName: string = '';
  deviceUrl: string = '';
  devices: any[] = []; // Lista de dispositivos
  id: number = 0;
  idRol: number = 0;
  selected: boolean = false;

  selectedDevice: any = null; // Dispositivo seleccionado
  dev: boolean = false;
  @Output() devModal: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router, private route: ActivatedRoute, private suscriptionService: SuscriptionService, private loginService: LoginService, 
  private deviceSelectionService: DeviceSelectionService, private translate: TranslateService) {
    this.id = this.loginService.chatCrmUser.id;
    this.idRol = this.loginService.chatCrmUser.idRol;
    // Establecer idiomas disponibles y el idioma por defecto
    translate.addLangs(['en', 'es']);
    translate.setDefaultLang('es');
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.deviceName = params['deviceName'] || '';
      this.deviceUrl = params['deviceUrl'] || '';
    });

    const storedDevice = this.deviceSelectionService.getSelectedDevice();
    if (storedDevice) {
      this.deviceName = storedDevice.nombre;
      this.deviceUrl = storedDevice.token;
    }

    this.obtenerDispositivos();

    // Obtener el parámetro 'lang' de la URL
    this.route.queryParams.subscribe(params => {
      const lang = params['lang'];
      if (lang) {
        this.translate.use(lang);
      } else {
        this.translate.use('es'); // Idioma por defecto
      }
    });
  }

  ngOnDestroy() {
    this.deviceSelectionService.clearSelectedDevice();
  }

  get filteredDevices() {
    return this.devices.filter(device => device.connected); 
  }

  obtenerDispositivos() {
    this.suscriptionService.obtenerSuscripcion(this.id, this.idRol).then(result => {
      this.devices = result.data;
    }).catch(error => {
      console.error('Error al obtener dispositivos:', error);
    });
  }

  showDevice(): void {
    this.dev = !this.dev;
  }

  seleccionarDispositivo(device: any) {
    this.deviceName = device.nombre;
    this.deviceUrl = device.token;
    this.deviceSelectionService.setSelectedDevice(device);
    this.dev = false; // Close the dropdown after selection
    
    // Update the URL with the selected device
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        deviceName: this.deviceName,
        deviceUrl: this.deviceUrl
      },
      queryParamsHandling: 'merge'
    });
  }

  envioMasivoMensaje(deviceUrl: string, deviceName: string) {
    this.router.navigate(["/message-multiple-contacts"], {
      queryParams: { deviceUrl: deviceUrl, deviceName: deviceName },
      queryParamsHandling: 'merge'
    });
  }

  envioMasivoArchivo(deviceUrl: string, deviceName: string) {
    this.router.navigate(["/file-multiple-contacts"], {
      queryParams: { deviceUrl: deviceUrl, deviceName: deviceName }, 
      queryParamsHandling: 'merge'
    });
  }

  mensajePersonalizadoGrupo(deviceUrl: string, deviceName: string) {
    this.router.navigate(["/personalized-message-multiple-contacts"], {
      queryParams: { deviceUrl: deviceUrl, deviceName: deviceName },
      queryParamsHandling: 'merge'
    });
  }

  archivoPersonalizadoGrupo(deviceUrl: string, deviceName: string) {
    this.router.navigate(["/personalized-file-multiple-contacts"], {
      queryParams: { deviceUrl: deviceUrl, deviceName: deviceName },
      queryParamsHandling: 'merge'
    });
  }

  listaDeContactos(deviceUrl: string, deviceName: string) {
    this.router.navigate(["/contact-list"], {
      queryParams: { deviceUrl: deviceUrl, deviceName: deviceName },
      queryParamsHandling: 'merge'
    });
  }

  myCampaigns(deviceUrl: string, deviceName: string) {
    this.router.navigate(["/my-campaigns"], {
      queryParams: { deviceUrl: deviceUrl, deviceName: deviceName },
      queryParamsHandling: 'merge'
    });
  }
}
